import script from "./AboutBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutBanner.vue?vue&type=script&setup=true&lang=ts"

import "./AboutBanner.vue?vue&type=style&index=0&id=22178c10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22178c10"]])

export default __exports__